var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3DWithColorSparkBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51157 1.54175C8.9823 2.22003 8.6665 3.07306 8.6665 4.00008C8.6665 6.20922 10.4574 8.00008 12.6665 8.00008C13.2615 8.00008 13.8257 7.86915 14.3332 7.63615V11.6667L7.99984 15.3334L1.6665 11.6667V4.33341L7.99984 0.666748L9.51157 1.54175ZM2.99984 10.8979L7.99984 13.7931V8.00008L2.99984 5.1049V10.8979ZM12.3527 1.54631C12.4704 1.26241 12.8627 1.26241 12.9803 1.54631L13.1489 1.95385C13.4369 2.64905 13.9742 3.2042 14.6496 3.50464L15.1281 3.71753C15.4016 3.83942 15.4016 4.23755 15.1281 4.35945L14.6216 4.58471C13.9631 4.87757 13.4354 5.41304 13.1424 6.08537L12.9777 6.46232C12.8574 6.73842 12.4756 6.73842 12.3553 6.46232L12.1912 6.08537C11.8982 5.41294 11.37 4.8776 10.7114 4.58471L10.2049 4.35945C9.93144 4.23756 9.93144 3.83941 10.2049 3.71753L10.6834 3.50464C11.3588 3.2042 11.8962 2.64907 12.1841 1.95385L12.3527 1.54631Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3529 1.54617C12.4706 1.26228 12.8629 1.26227 12.9805 1.54617L13.1491 1.95372C13.4371 2.64892 13.9744 3.20407 14.6498 3.50451L15.1283 3.71739C15.4018 3.83929 15.4018 4.23741 15.1283 4.35932L14.6218 4.58458C13.9633 4.87744 13.4356 5.41291 13.1426 6.08523L12.9779 6.46219C12.8576 6.73828 12.4758 6.73828 12.3555 6.46219L12.1914 6.08523C11.8984 5.41281 11.3702 4.87747 10.7116 4.58458L10.2051 4.35932C9.93163 4.23743 9.93163 3.83927 10.2051 3.71739L10.6836 3.50451C11.359 3.20407 11.8964 2.64893 12.1843 1.95372L12.3529 1.54617Z",
    fill: "url(#paint0_linear_4261_679)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4261_679",
    x1: 12.5,
    y1: 1,
    x2: 12.5,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C48D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#BAA3FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DWithColorSparkBlack);
export default __webpack_public_path__ + "static/media/3d-with-color-spark-black.636e180f1cc220f993a18e3e8b364aa3.svg";
export { ForwardRef as ReactComponent };